import { useMemo } from "react";

const useRowData = <T extends any>({
	data: dataProp,
	numColumns,
	keyExtractor,
}: {
	data: readonly T[] | null | undefined;
	numColumns: number;
	keyExtractor: ((item: T, index: number) => string) | undefined;
}) => {
	const rowData = useMemo(() => {
		const retData: { rowKey: string; rows: T[] }[] = [];
		const data = dataProp ?? [];
		for (let i = 0; i < data.length; i += numColumns) {
			const row = data.slice(i, i + numColumns);
			const rowKey = keyExtractor
				? row.map((item, i) => keyExtractor(item, i)).join("-")
				: `${i}`;
			retData.push({ rowKey, rows: row });
		}
		return retData;
	}, [dataProp, keyExtractor, numColumns]);
	return rowData;
};
export default useRowData;
